const goToHash = () => {
    let hash = window.location.hash.substring(1);

    if(hash && !document.querySelector('.tabHash')){
        let target = document.getElementById(hash);
        if(target) {
            let headerOffset = document.querySelector(".site-header").offsetHeight;
            let elementPosition = target.getBoundingClientRect().top;
            let offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            setTimeout(function(){
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            },100);
        }
    }
};
export default goToHash;
